import React, {MouseEvent, useCallback, useEffect, useState} from "react"
import styles from '../css/Avatar.module.css'
import textStyles from '../css/Text.module.css';
import LoadingSpinner from "./LoadingSpinner";
import {usePrevious} from "../utils/HooksHelper";
import {isMobile} from "react-device-detect";

interface Props {
    hint?: string,
    size?: number,
    src?: string,
    onError?: () => void,
    onLoad?: () => void,
    onClick?: (event: MouseEvent) => void
}

export default (props: Props) => {

    // Props

    const {hint, src, onLoad, size, onError, onClick} = props;

    const [isLoading, setIsLoading] = useState(true);

    const handleOnLoad = useCallback(
        () => {
            setTimeout(() => {
                // Using timeout because of an issue with Safari desktop which call this function before
                // useEffect setIsLoading(true)
                setIsLoading(false);
                onLoad && onLoad();
            }, isMobile ? 50 : 10);
        },
        [onLoad, setIsLoading]
    );

    const prevSrc = usePrevious(src);

    // Effects

    useEffect(() => {

        if (!isLoading && src === prevSrc) {
            handleOnLoad();
        }

    });

    useEffect(() => {
        setIsLoading(true)
    }, [src]);

    const style = size ? {height: size, width: size} : undefined;

    return (
        <>
            <div className={styles.avatarContainer}>
                <button disabled={!onClick} className={styles.avatarButton}>
                    {
                        isLoading &&
                        <>
                            <div className={styles.avatarIsLoading}>
                                <LoadingSpinner/>
                            </div>
                        </>
                    }
                    <img onError={onError} onClick={onClick} src={src} alt="Avatar"
                         onLoad={handleOnLoad}
                         className={styles.avatar}
                         style={style}/>
                </button>
            </div>
            {hint ? <p className={textStyles.hint}>{hint}</p> : null}
        </>
    );
}